export default __webpack_public_path__ + "static/media/review_bg.a5e70819.png";